module.exports = __webpack_public_path__ + "img/Acc-5.adb6feb1.png";